import { createContext, type ReactNode, useContext, useState } from "react";

export interface formCreateContextType {
  formCreateResume: boolean;
  setformCreateResume: (open: boolean) => void;
}
export const FormCreateResumeContext = createContext<formCreateContextType | undefined>(undefined);

export const FormCreateResumeProvider = ({ children }: { children: ReactNode }) => {
  const [formCreateResume, setformCreateResume] = useState(false);
  return (
    <FormCreateResumeContext.Provider value={{ formCreateResume, setformCreateResume }}>
      {children}
    </FormCreateResumeContext.Provider>
  );
};

export const useFormResumeCreate = () => {
  const context = useContext(FormCreateResumeContext);
  return context;
};
